import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import CardActionArea from '@material-ui/core/CardActionArea';
import {
    Container,
    Paper,
    Grid,
    Breadcrumbs,
    Typography,
    TextField,
    CardMedia,
    Card,
    CardContent,
    CardActions,
    ButtonGroup
} from "@material-ui/core";
import Imagen from '../../img/Punto5_Portada.png'

const style = {
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: 650
    },
    link: {
        // display: "flex",
        textDecoration: "none"
    },
    gridTextfield: {
        marginTop: "20px"
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column"

    },
    cardMedia: {
        paddingTop: "56.25%"
    },
    cardContent: {
        flexGrow: 1
    },
    barraBoton: {
        marginTop: "10px"
    }
};


const CompCiclo = ({props, ciclo, index }) => {

    let idCiclo = ciclo.id;
    let tituloCiclo = ciclo.tituloCiclo;

//  const   irListaCursos = (idCiclo) => {
//         props.history.push(`/cursos/${idCiclo}`);
//     }

    return (
       
            <Grid item key={ciclo.id} xs={12} sm={6} md={4}>
                <Card style={style.card}>
                <CardActionArea >
                <Link to={`/cursos/${ciclo.id}`} style={style.link} >
                    <CardMedia
                        style={style.cardMedia}
                        image={Imagen}
                        title="Mi Curso"
                    />
                    <CardContent style={style.cardContent}>
                        <Typography gutterBottom variant="h5" component="h2">
                         {tituloCiclo}
                        </Typography>
                    </CardContent>
                    </Link>
                </CardActionArea>
                </Card>
            </Grid>       
    )
}

export default withRouter(CompCiclo)
